import { IDataArray } from './../index';

export class UserCompany implements IDataArray {
	public UserId: number;
	public CompanyId: number;

	public GetById(): number {
		return this.UserId;
	}
}
